module.exports = __webpack_public_path__ + "img/busy-background.5fc649fa.png";